import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Navbar from '../Component/Navbar'
import axiosInstance from '../Api/axiosInstance'

const statusMap = {
    1: { label: 'Pending', color: '#e6a817', bg: '#fff8e6', border: '#e6a81740' },
    2: { label: 'Assigned', color: '#4a7c59', bg: '#e8f5ee', border: '#4a7c5940' },
    3: { label: 'Completed', color: '#2d6a4f', bg: '#d8f3dc', border: '#2d6a4f40' },
    4: { label: 'Cancelled', color: '#c1121f', bg: '#ffe5e5', border: '#c1121f40' },
}

const navItems = [
    { label: 'Dashboard', icon: '📊', path: '/dashboard' },
    { label: 'Trip Details', icon: '🚚', path: '/trip-details' },
    { label: 'Saved Address', icon: '📍', path: '/save-address' },
    { label: 'Employee Details', icon: '👤', path: '/employee-request' },
    { label: 'Branch Details', icon: '🏢', path: '/branch-details' },
    { label: 'Account', icon: '📋', path: '/account' },
]

const OL = '#6b7c3e', OL_PALE = '#f0f4e8', OL_DARK = '#3d4a22'

export default function ViewTrip() {
    const { tripId } = useParams()
    const navigate = useNavigate()
    const [trip, setTrip] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [activeNav, setActiveNav] = useState('Trip Details')

    useEffect(() => {
        const fetchTrip = async () => {
            setLoading(true)
            setError(null)
            try {
                const res = await axiosInstance.get(
                    `/enterprise/trip/details/${tripId}`,
                    { useAuth: true }
                )
                setTrip(res.data?.data || null)
            } catch (err) {
                console.error('Failed to fetch trip:', err)
                setError('Failed to load trip details. Please try again.')
                setTrip(null)
            } finally {
                setLoading(false)
            }
        }
        fetchTrip()
    }, [tripId])

    const sortedStops = [...(trip?.stops || [])].sort((a, b) => a.sequence - b.sequence)
    const [pickupStop, ...deliveryStops] = sortedStops

    const status = statusMap[trip?.status] || statusMap[1]
    const vehicle = trip?.vehiclesDetails || trip?.estimatedCost?.data
    const enterprise = trip?.enterpriseDetails
    const payment = trip?.paymentDetails?.billDetails

    return (
        <>
            <Navbar />
            <div style={{ display: 'flex', minHeight: '100vh', fontFamily: "'DM Sans', sans-serif", background: '#f7f8f4' }}>

                {/* ── Sidebar ── */}
                <aside style={{ width: 220, background: '#fff', borderRight: '1px solid #e0e5d4', display: 'flex', flexDirection: 'column', padding: '24px 0', flexShrink: 0, boxShadow: '2px 0 12px rgba(107,124,62,0.07)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0 20px 24px', borderBottom: '1px solid #e8eedd', marginBottom: 12 }}>
                        <span style={{ fontSize: 22 }}>🚛</span>
                        <span style={{ fontSize: 18, fontWeight: 700, color: OL_DARK }}>Menu</span>
                    </div>
                    <nav style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '0 10px' }}>
                        {navItems.map(item => (
                            <button key={item.label} 
                            onClick={() => {
                                setActiveNav(item.label)
                                navigate(item.path)
                            }}
                                style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 10, border: 'none', width: '100%', cursor: 'pointer', fontSize: 14, fontWeight: activeNav === item.label ? 600 : 500, color: activeNav === item.label ? OL_DARK : '#666', background: activeNav === item.label ? OL_PALE : 'transparent', fontFamily: "'DM Sans', sans-serif", position: 'relative', textAlign: 'left' }}>
                                <span>{item.icon}</span><span>{item.label}</span>
                                {activeNav === item.label && <span style={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', width: 3, height: 20, borderRadius: '0 3px 3px 0', background: OL }} />}
                            </button>
                        ))}
                    </nav>
                </aside>

                {/* ── Main ── */}
                <main style={{ flex: 1, padding: '32px 36px', overflowY: 'auto' }}>
                    {loading ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300 }}>
                            <div style={{ width: 36, height: 36, border: `3px solid ${OL_PALE}`, borderTop: `3px solid ${OL}`, borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
                            <p style={{ color: '#888', marginTop: 14 }}>Loading trip details…</p>
                        </div>
                    ) : error ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300, gap: 12 }}>
                            <span style={{ fontSize: 40 }}>⚠️</span>
                            <p style={{ color: '#c1121f', fontWeight: 600 }}>{error}</p>
                            <button onClick={() => window.location.reload()} style={{ padding: '8px 20px', background: OL, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}>Retry</button>
                        </div>
                    ) : !trip ? (
                        <p style={{ color: '#c1121f' }}>Trip not found.</p>
                    ) : (
                        <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8d4', boxShadow: '0 2px 16px rgba(107,124,62,0.07)', overflow: 'hidden' }}>

                            {/* Header */}
                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', padding: '20px 28px' }}>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                                    <button onClick={() => navigate(-1)} style={{ fontSize: 28, background: 'none', border: 'none', cursor: 'pointer', color: '#555', lineHeight: 1, fontFamily: 'sans-serif' }}>‹</button>
                                    <div>
                                        <div>
                                            <span style={{ fontSize: 15, fontWeight: 600, color: '#555' }}>Trip ID: </span>
                                            <span style={{ fontSize: 15, fontWeight: 700, color: '#27a86e', fontFamily: "'JetBrains Mono', monospace" }}>{trip.tripCode} ({trip.totalDistance} kms)</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 5 }}>
                                            <span style={{ fontSize: 13, color: '#777' }}>Payment — ₹ {payment?.netFare || '—'}</span>
                                            <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 20, textTransform: 'uppercase', color: status.color, background: status.bg, border: `1px solid ${status.border}` }}>{status.label}</span>
                                        </div>
                                    </div>
                                </div>
                                <span style={{ fontSize: 13, fontWeight: 700, padding: '6px 18px', borderRadius: 20, color: status.color, background: status.bg, border: `1.5px solid ${status.border}`, alignSelf: 'center' }}>Trip {status.label}</span>
                            </div>

                            <div style={{ height: 1, background: '#eef1e8', margin: '0 28px' }} />

                            {/* Sender Details */}
                            <section style={{ padding: '20px 28px' }}>
                                <h2 style={{ fontSize: 17, fontWeight: 700, color: OL_DARK, marginBottom: 14 }}>Sender Details</h2>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                                    <div>
                                        {[['Email', enterprise?.email], ['Contact', `+91 ${enterprise?.phone}`], ['GST', enterprise?.gstNumber || '—']].map(([lbl, val]) => (
                                            <p key={lbl} style={{ fontSize: 14, color: '#444', marginBottom: 6 }}>
                                                <span style={{ fontWeight: 600, color: '#555', marginRight: 4 }}>{lbl}:</span>{val}
                                            </p>
                                        ))}
                                    </div>
                                    <div>
                                        <p style={{ fontSize: 14, color: '#444', marginBottom: 6 }}><span style={{ fontWeight: 600, color: '#555', marginRight: 4 }}>Address:</span></p>
                                        <p style={{ color: '#555', fontSize: 14 }}>{enterprise?.address}</p>
                                    </div>
                                </div>
                            </section>

                            <div style={{ height: 1, background: '#eef1e8', margin: '0 28px' }} />

                            {/* Vehicle Details */}
                            <section style={{ padding: '20px 28px' }}>
                                <h2 style={{ fontSize: 17, fontWeight: 700, color: OL_DARK, marginBottom: 14 }}>Vehicle Details</h2>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
                                    <img
                                        src={vehicle?.images || vehicle?.vehicleImage}
                                        alt="vehicle"
                                        style={{ width: 72, height: 52, objectFit: 'contain', borderRadius: 8, background: OL_PALE, padding: 6 }}
                                        onError={e => { e.target.style.display = 'none' }}
                                    />
                                    <div>
                                        <p style={{ fontSize: 14, color: '#444', marginBottom: 6 }}>
                                            <span style={{ fontWeight: 600, color: '#555', marginRight: 4 }}>Type:</span>
                                            {vehicle?.type || vehicle?.vehicleType}
                                        </p>
                                        <p style={{ fontSize: 14, color: '#444' }}>
                                            <span style={{ fontWeight: 600, color: '#555', marginRight: 4 }}>Capacity:</span>
                                            {vehicle?.vehicleCapacity} kg
                                        </p>
                                    </div>
                                </div>
                            </section>

                            <div style={{ height: 1, background: '#eef1e8', margin: '0 28px' }} />

                            {/* Pickup Stop */}
                            {pickupStop && (
                                <section style={{ padding: '20px 28px' }}>
                                    <div style={{ background: '#f6fbf7', border: '1.5px solid #b7d9c2', borderLeft: '4px solid #27a86e', borderRadius: 10, padding: '16px 20px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                                            <span>📍</span>
                                            <span style={{ fontSize: 15, fontWeight: 700, color: '#27a86e' }}>From Address</span>
                                            <span style={{ marginLeft: 'auto', fontSize: 12, fontWeight: 700, background: '#27a86e', color: '#fff', borderRadius: 20, padding: '2px 12px' }}>Pickup</span>
                                        </div>
                                        <p style={{ fontSize: 15, fontWeight: 600, color: OL_DARK, marginBottom: 4 }}>{pickupStop.name}</p>
                                        <p style={{ fontSize: 13, color: '#666' }}>{pickupStop.address}</p>
                                        {pickupStop.contactName && (
                                            <p style={{ fontSize: 13, color: '#888', marginTop: 6 }}>
                                                {pickupStop.contactName} | +91 {pickupStop.contactPhone}
                                            </p>
                                        )}
                                    </div>
                                </section>
                            )}

                            {/* Delivery Stops */}
                            {deliveryStops.length > 0 && (
                                <section style={{ padding: '0 28px 28px' }}>
                                    <h2 style={{ fontSize: 17, fontWeight: 700, color: OL_DARK, marginBottom: 14 }}>Delivery Stops</h2>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                                        {deliveryStops.map((stop, idx) => {
                                            const ss = statusMap[stop.status] || statusMap[1]
                                            return (
                                                <div key={stop._id} style={{ border: '1.5px solid #e0e8d4', borderLeft: '4px solid #6b7c3e', borderRadius: 10, padding: '14px 18px', background: '#fafcf6' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                                                        <div>
                                                            <span style={{ fontSize: 14, fontWeight: 700, color: OL_DARK }}>Stop {idx + 1}</span>
                                                            <span style={{ margin: '0 6px', color: '#bbb' }}>·</span>
                                                            <span style={{ fontSize: 14, fontWeight: 600, color: '#444' }}>{stop.name}</span>
                                                        </div>
                                                        <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 12px', borderRadius: 20, color: ss.color, background: ss.bg, border: `1px solid ${ss.border}` }}>{ss.label}</span>
                                                    </div>
                                                    <p style={{ fontSize: 13, color: '#666', marginBottom: 6 }}>📍 {stop.address}</p>
                                                    <p style={{ fontSize: 13, color: '#777', marginBottom: 8 }}>
                                                        <span style={{ fontWeight: 600, color: '#555' }}>{stop.contactName}</span> | +91 {stop.contactPhone}
                                                    </p>
                                                    {stop.segmentDistance > 0 && (
                                                        <p style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>
                                                            📏 Segment Distance: <strong>{stop.segmentDistance} km</strong>
                                                        </p>
                                                    )}
                                                    <span style={{ display: 'inline-block', fontSize: 12, fontWeight: 600, color: '#27a86e', background: '#e8f8f0', border: '1px solid #b7d9c2', borderRadius: 20, padding: '3px 12px' }}>
                                                        {stop.isPaymentCollect ? '💳 Payment Required' : 'Payment: Not Required'}
                                                    </span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </section>
                            )}

                            {/* Bill Summary */}
                            {payment && (
                                <>
                                    <div style={{ height: 1, background: '#eef1e8', margin: '0 28px' }} />
                                    <section style={{ padding: '20px 28px' }}>
                                        <h2 style={{ fontSize: 17, fontWeight: 700, color: OL_DARK, marginBottom: 14 }}>Bill Summary</h2>
                                        <div style={{ background: OL_PALE, borderRadius: 10, padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 340 }}>
                                            {[
                                                ['Total Amount', `₹ ${payment.totalAmount || '—'}`],
                                                ['Labour Cost', `₹ ${payment.labourCost || '0.00'}`],
                                                ['Coupon Discount', `₹ ${payment.couponDiscount || '0'}`],
                                            ].map(([lbl, val]) => (
                                                <div key={lbl} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#555' }}>
                                                    <span>{lbl}</span><span style={{ fontWeight: 600 }}>{val}</span>
                                                </div>
                                            ))}
                                            <div style={{ height: 1, background: '#d4dfc0', margin: '4px 0' }} />
                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 15, fontWeight: 700, color: OL_DARK }}>
                                                <span>Net Fare</span>
                                                <span style={{ color: '#27a86e' }}>₹ {payment.netFare}</span>
                                            </div>
                                        </div>
                                    </section>
                                </>
                            )}

                        </div>
                    )}
                </main>

                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@500&display=swap');
                    * { box-sizing: border-box; margin: 0; padding: 0; }
                    @keyframes spin { to { transform: rotate(360deg); } }
                `}</style>
            </div>
        </>
    )
}